module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "sample-check.093a76fc.png";